import { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import Lottie from "lottie-react";
import astra from "assets/animations/bot/astra.json";
import solara from "assets/animations/bot/solaraagent 2.json";
import arrow from "assets/animations/bot/nextArrow.json";
import BotVcc from "assets/Icons/vccAgentBg.svg";
import ceres from "assets/animations/bot/ceresagent4";
import { useNavigate, useLocation } from "react-router-dom";
// import { startDeclarationBotAgent } from "utils/lambda";
import { ErrorToaster, 
  // SuccessToaster
 } from "components/Toaster";
// import { startVccBotAgent } from "utils/lambda";
// import { runVccBotAgent } from "utils/lambda";
import { runDeclarationBotAgent } from "utils/lambda";
import { FontFamily } from "assets";


const DeclrationVccAgent = () => {
  const [started] = useState("idle");
  const navigate = useNavigate();
  const [isStarting, setIsStarting] = useState(false);
  const location = useLocation();

  if (started !== "idle") return null;

  // const DECL_KEY = "decl_payload_latest";
  // const VCC_KEY = "vcc_payload_latest";


  // const runProcessingVcc = async () => {
  //   try {
  //     setIsStarting(true);

  //     const raw = localStorage.getItem("vcc_payload_latest");

  //     if (!raw) {
  //       ErrorToaster("Uploaded file not found. Please upload again.");
  //       return;
  //     }
  //     const payload = JSON.parse(raw);

  //     await startVccBotAgent(payload);

  //     SuccessToaster("Processing started.");
  //     localStorage.removeItem("vcc_payload_latest");

  //     // navigate("/agents-progress");
  //   } catch (e) {
  //     console.error(e);
  //     ErrorToaster(e);
  //   } finally {
  //     setIsStarting(false);
  //   }
  // };


  // const runProcessing = async () => {
  //   try {
  //     const declRaw = localStorage.getItem(DECL_KEY);
  //     const vccExists = !!localStorage.getItem(VCC_KEY);

  //     setIsStarting(true);

  //     if (!declRaw && !vccExists) {
  //       ErrorToaster("Uploaded Files not found. Please upload again.");
  //       return;
  //     }

  //     if (declRaw) {
  //       try {
  //         const declPayload = JSON.parse(declRaw);
  //         await startDeclarationBotAgent(declPayload);
  //         SuccessToaster("Declaration processing started.");
  //       } catch (e) {
  //         console.error(e);
  //         ErrorToaster(e);
  //       } finally {
  //         localStorage.removeItem(DECL_KEY);
  //       }
  //     }

  //     if (vccExists) {
  //       await runProcessingVcc();
  //     }

  //     navigate("/agents-progress");
  //   } catch (e) {
  //     console.error(e);
  //     ErrorToaster(e);
  //   } finally {
  //     setIsStarting(false);
  //   }
  // };


  const runProcessing = async () => {
    if (isStarting) return;
    setIsStarting(true);

    try {

      const hasDecl = true;
      const hasVcc = true;

      const jobs = [];
      let declarationSuccess = false;
      let vccSuccess = false;


      if (hasDecl) {
        jobs.push(
          (async () => {
            try {
              const declPayload = {
                table: "both",
              };
              await runDeclarationBotAgent(declPayload);
              declarationSuccess = true;
              // SuccessToaster("Declaration processed.");
            } catch (e) {
              console.error(e);
              ErrorToaster(e?.message);
            }
            
          })()
        );
      }

      // if (declarationSuccess) {
      //   jobs.push(
      //     (async () => {
      //       try {
      //         const vccPayload = {
      //           table: "vcc-execution"
      //         };
      //         await runVccBotAgent(vccPayload);
      //         vccSuccess = true;
      //         // SuccessToaster("VCC processing started.");
      //       } catch (e) {
            
      //         console.error(e);
      //         ErrorToaster(e?.message);
      //       }
            
      //     })()
      //   );
      // }

      await Promise.all(jobs);

      if (declarationSuccess) {
        navigate("/agents-progress");
      }
    } catch (e) {
      console.error(e);
      ErrorToaster(e);
    } finally {
      setIsStarting(false);
    }
  };



  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundImage: `url(${BotVcc})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        color: "white",
        display: "flex",
        flexDirection: "column",
        py: 4,
      }}
    >
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        columnSpacing={4}
        rowSpacing={0}
        sx={{ maxWidth: "1400px", mx: "auto" }}
      >
        <Grid
          item
          md={3}
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "left",
          }}
        >
          <Lottie
            animationData={astra}
            loop
            style={{
              width: "271px",
              height: "373px",
            }}
          />

          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "26px",
              textAlign: "center",
              color: "white",
              border: "2px solid white",
              borderRadius: "100px",
              paddingTop: "12px",
              paddingBottom: "12px",
              paddingRight: "50px",
              paddingLeft: "50px",
              marginBottom: "20px",
              fontFamily: FontFamily.openSans,
              fontWeight: 400,
              fontStyle: "Regular",

            }}
          >
            Agent Astra
          </Typography>

          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 600,
              color: "#fff",
              textAlign: "center",
              mb: 2,
              fontFamily: FontFamily.openSans, fontWeight: 400, fontStyle: "Regular",
            }}
          >
            The VCC Data Manager
          </Typography>

          <Box
            component="ul"
            sx={{
              m: 0,
              p: 0,
              maxWidth: "320px",
              color: "#fff",
              fontSize: "20px",
              lineHeight: 1.5,
              fontFamily: FontFamily.openSans,
              fontWeight: 400, fontStyle: "Regular",
              "& li": {
                position: "relative",
                paddingLeft: "20px",
                marginBottom: "16px",
                listStyle: "none",
                fontFamily: FontFamily.openSans,
                fontWeight: 400, fontStyle: "Regular",
              },
              "& li::before": {
                content: '""',
                position: "absolute",
                left: 0,
                top: "8px",
                width: "6px",
                height: "6px",
                backgroundColor: "#fff",
                fontFamily: FontFamily.openSans,
                fontWeight: 400, fontStyle: "Regular",
              },
            }}
          >
            <li>
              Processes Dec &amp; VCC docs, sorting data by container and VIN.
            </li>
            <li>
              Organizes data according to Galaxy ERP requirements.
            </li>
            <li>
              Will soon integrate with Dubai Trade to fetch real-time.
            </li>
            <li>
              Verifies status, downloads documents, and updates ERP with
              declaration and payment info.
            </li>
            <li>
              Transfers organized data to the next agent in the process.
            </li>
          </Box>
        </Grid>

        <Grid
          item
          md={1}
          xs={12}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            pt: { md: "120px", xs: 2 },
          }}
          mt={7}
        >
          <Lottie
            animationData={arrow}
            loop
            style={{
              width: "77px",
              height: "93px",
            }}
          />
        </Grid>

        <Grid
          item
          md={3}
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "left",
          }}
        >
          <Lottie
            animationData={solara}
            loop
            style={{
              width: "271px",
              height: "373px",
            }}
          />

          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "26px",
              fontWeight: 600,
              textAlign: "center",
              color: "white",
              border: "2px solid white",
              borderRadius: "100px",
              paddingTop: "12px",
              paddingBottom: "12px",
              paddingRight: "50px",
              paddingLeft: "50px",
              marginBottom: "20px",
              fontFamily: FontFamily.openSans,
              fontWeight: 400, fontStyle: "Regular",
            }}
          >
            Agent Solara
          </Typography>

          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 600,
              color: "#fff",
              textAlign: "center",
              mb: 2,
              fontFamily: FontFamily.openSans,
              fontWeight: 400, fontStyle: "Regular",
            }}
          >
            The VCC &amp; Dec Coordinator
          </Typography>

          <Box
            component="ul"
            sx={{
              m: 0,
              p: 0,
              maxWidth: "320px",
              color: "#fff",
              fontSize: "20px",
              lineHeight: 1.5,
              fontWeight: 400,
              fontFamily: FontFamily.openSans,
              fontWeight: 400, fontStyle: "Regular",
              "& li": {
                position: "relative",
                paddingLeft: "20px",
                marginBottom: "16px",
                listStyle: "none",
              },
              "& li::before": {
                content: '""',
                position: "absolute",
                left: 0,
                top: "8px",
                width: "6px",
                height: "6px",
                backgroundColor: "#fff",
                fontFamily: FontFamily.openSans,
                fontWeight: 400, fontStyle: "Regular",
              },
            }}
          >
            <li>
              Adds VCC records into the system on a container- and VIN-wise
              basis.
            </li>
            <li>
              Creates and maintains the linkage between Declaration documents
              and corresponding VCC attachments.
            </li>
            <li>
              Ensures all data is accurately organized and traceable within the
              ERP system.
            </li>
            <li>
              Hands over the verified and linked data to the next agent in the
              process.
            </li>
          </Box>
        </Grid>

        <Grid
          item
          md={1}
          xs={12}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            pt: { md: "120px", xs: 2 },
          }}
          mt={7}
        >
          <Lottie
            animationData={arrow}
            loop
            style={{
              width: "77px",
              height: "93px",
            }}
          />
        </Grid>

        <Grid
          item
          md={3}
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "left",
          }}
        >
          <Lottie
            animationData={ceres}
            loop
            style={{
              width: "271px",
              height: "373px",
            }}
          />

          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "26px",
              fontWeight: 600,
              textAlign: "center",
              color: "white",
              border: "2px solid white",
              borderRadius: "100px",
              paddingTop: "12px",
              paddingBottom: "12px",
              paddingRight: "50px",
              paddingLeft: "50px",
              marginBottom: "20px",
              fontFamily: FontFamily.openSans,
              fontWeight: 400, fontStyle: "Regular",
            }}
          >
            Agent Ceres
          </Typography>

          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 600,
              color: "#fff",
              textAlign: "center",
              mb: 2,
              fontFamily: FontFamily.openSans,
              fontWeight: 400, fontStyle: "Regular",
            }}
          >
            The Custom Acc Officer
          </Typography>

          <Box
            component="ul"
            sx={{
              m: 0,
              p: 0,
              maxWidth: "320px",
              color: "#fff",
              fontSize: "20px",
              lineHeight: 1.5,
              fontWeight: 400,
              fontFamily: FontFamily.openSans,
              fontWeight: 400, fontStyle: "Regular",
              "& li": {
                position: "relative",
                paddingLeft: "20px",
                marginBottom: "16px",
                listStyle: "none",
              },
              "& li::before": {
                content: '""',
                position: "absolute",
                left: 0,
                top: "8px",
                width: "6px",
                height: "6px",
                backgroundColor: "#fff",
                fontFamily: FontFamily.openSans,
                fontWeight: 400, fontStyle: "Regular",
              },
            }}

          >
            <li>Enters customs values for each transaction.</li>
            <li>
              Applies VAT (5%) and a 100 AED service charge per transaction.
            </li>
            <li>
              Creates the corresponding accounting entries in the ERP system.
            </li>
            <li>
              Ensures financial accuracy and compliance with customs
              regulations.
            </li>
            <li>Completes the workflow after validation.</li>
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 4,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#5BBC0F",
            border:"1px solid #5BBC0F",
            borderRadius: "100px",
            px: "24px",
            py: "12px",
            fontSize: "22px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
            color: "#fff",
            fontFamily: FontFamily.openSans,
            fontStyle: "Regular",
          }}
          component="button"
          type="button"
          onClick={runProcessing}
          disabled={isStarting}
          // style={{ opacity: isStarting ? 0.6 : 1, pointerEvents: isStarting ? "none" : "auto" }}
        >
          <span>{isStarting ? "Starting..." : "Start Processing Now"}</span>
          <span style={{ fontWeight: 700, fontSize: "18px" }}>➜</span>
        </Box>
      </Box>
    </Box >
  );
};

export default DeclrationVccAgent;
